export default __webpack_public_path__ + "images/GN.27b6cba.png";